<template>
<body style="background-color:#D6D6D6">
    <div id="fondos">

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
            <!--<v-layout row wrap>
            <v-flex sm4 md4 lg3 class="pl-4 ml-4 pt-5" >
            <v-card style="background-color:#4D93A8">
              <v-card-title><span class="titlecuentos" style="color:white; font-family:Poppins;  font-weight:600">CUENTOS</span></v-card-title>
            </v-card>
            </v-flex>
            <v-flex md1 class="pt-5" >
            <v-card flat style="background-color:#D6D6D6">
              <img src="cuentos.png"  style="position:absolute;margin-left:-30px; margin-top:-2px" />
            </v-card>
            </v-flex>
            </v-layout>-->
            <ContentFondos :fondos="fondos">
            </ContentFondos>
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentFondos from "@/components/ContentFondos.vue"

export default {
   
    components:{
       ContentFondos
     },

    data(){
        return{
            title:"FONDOS VIRTUALES",
            fondos:[
          
          {title:"Salón de clases",img:"portada_salon1.jpg",url:"../descargas/files/fondosvirtuales/salon1.png",namedownload:"Salon_de_clases1"},
          {title:"Salón de clases 2",img:"portada_salon2.jpg",url:"../descargas/files/fondosvirtuales/salon2.png",namedownload:"Salon_de_clases1"},
          {title:"Salón de clases 3",img:"portada_salon3.jpg",url:"../descargas/files/fondosvirtuales/salon3.png",namedownload:"Salon_de_clases1"},
          {title:"Halloween",img:"fondo_halloween.png",url:"../descargas/files/fondosvirtuales/Fondo_Halloween.png",namedownload:"Halloween"},
          {title:"Dia de muertos",img:"fondo_dia_muertos.png",url:"../descargas/files/fondosvirtuales/Fondo_dia_muertos.png",namedownload:"Dia_de_muertos"},
          
        ]
        }
    }
}
</script>

<style scoped>
.actividad.cuento{
    background-color:#4D93A8; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1.5vw; 
    height: 60px;
  }

  @media (min-width: 1200px){
    .titlecuentos{
      font-size:1.2vw;
    }
  }
</style>


